import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataAllUserRolesState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataAllUserRolesReducer.allUserRolesFeatureKey]
);

export const getStaticDataAllUserRolesFailure = createSelector(
  getStaticDataAllUserRolesState,
  staticDataCountriesReducer.fromStaticDataAllUserRolesReducer.getAllUserRolesFailure
);

export const getStaticDataAllUserRolesResponse = createSelector(
  getStaticDataAllUserRolesState,
  staticDataCountriesReducer.fromStaticDataAllUserRolesReducer.getAllUserRolesResponse
);

export const getStaticDataAllUserRolesisLoaded = createSelector(
  getStaticDataAllUserRolesState,
  staticDataCountriesReducer.fromStaticDataAllUserRolesReducer.getAllUserRolesIsLoaded
);
